import React, { ElementType } from 'react';

import { Container, Row } from "react-bootstrap";


import SectionContainerHeaderComponent from "@Components/Sections/SectionContainer/SectionContainerHeader";


import "./index.scss";


type SectionContainerProps = {
    id: string;
    sectionHeaderText?: string;
    sectionDescriptionText?: string;
    sectionType?: 'default' | 'main';
    as?: ElementType;
    children?: React.ReactNode;
    ref?: React.ForwardedRef<any>;
    extraClassName?: string;
};


export const SectionContainerComponent:React.FC<SectionContainerProps> = ({
    id,
    sectionHeaderText, sectionDescriptionText, sectionType = 'default',
    as, children, ref, extraClassName = ''
}) => {

    return (
        <Container as={as} fluid={true} className={`${id} section-container ${sectionType}-section-type ${extraClassName}`} ref={ref}>
            <Container className={`${id}__content section-container__content`}>
                <Row className={`${id}__content__row section-container__content__row`}>

                    <SectionContainerHeaderComponent
                        headerText={sectionHeaderText}
                        descriptionText={sectionDescriptionText}
                    />

                    {children}

                </Row>
            </Container>
        </Container>
    );

};


export default SectionContainerComponent;
